goog.provide("shadow.js.shim.module$src$svg$artwork$connection_error_svg$default");
shadow.js.shim.module$src$svg$artwork$connection_error_svg$default = shadow.js.shim.module$src$svg$artwork$connection_error_svg.default;
